import { useMemo } from 'react';

export const TableConfig = () => {
  const columns = useMemo(
    () => [
      {
        Header: 'Id',
        accessor: 'id',
      },
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Jira',
        accessor: 'jira_code',
      },
      {
        Header: 'Logged Hours',
        accessor: 'total_logged_hours',
      },
      {
        Header: 'Paid Hours',
        accessor: 'total_paid_hours',
      },
      {
        Header: 'Approved Hours',
        accessor: 'total_approved_hours',
      },
      {
        Header: 'Cost',
        accessor: 'cost',
      },
      {
        Header: 'Date Start',
        accessor: 'date_start',
      },
      {
        Header: 'Date End',
        accessor: 'date_end',
      },
      {
        Header: 'Developers',
        accessor: 'developers',
        disableGlobalFilter: true,
        disableSortBy: true,
      },
      {
        Header: 'Clients',
        accessor: 'clients',
        disableGlobalFilter: true,
        disableSortBy: true,
      },
      {
        Header: 'Actions',
        accessor: 'actions',
        disableGlobalFilter: true,
        disableSortBy: true,
      },
    ],
    [],
  );

  return {
    columns,
  };
};